var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getMissionNotificationRecipientsByMissionIdFunctionDef, } from '../../../../backend/features/message/platform-functions/shared/getMissionNotificationRecipientsByMissionIdSchema';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import useSWR from 'swr';
export const getQualifiedVolunteerAccountIdsByMissionIdFetchKey = 'getQualifiedVolunteerAccountIdsByMissionId';
export function useMissionNotificationRecipientsByMissionId(requestParams) {
    const getQualifiedVolunteerAccountIdsByMissionIdPlatformFn = useTypedPlatformFunction(getMissionNotificationRecipientsByMissionIdFunctionDef);
    const fetch = () => {
        return getQualifiedVolunteerAccountIdsByMissionIdPlatformFn(requestParams);
    };
    const { data, mutate, isLoading } = useSWR([getQualifiedVolunteerAccountIdsByMissionIdFetchKey, ...Object.values(requestParams)], () => {
        if (!requestParams.missionId) {
            return undefined;
        }
        return fetch().catch(handleErrorSnackbar);
    }, defaultFetcherOptions);
    return {
        participants: data,
        isLoading,
        fetchParticipants: () => __awaiter(this, void 0, void 0, function* () {
            yield mutate();
        }),
    };
}
